import { getUnreadCount } from "@api/chat";
import { getNotificationsHistory } from "@api/notifications";
import { type ParentComponent, createContext, onMount } from "solid-js";
import { createStore } from "solid-js/store";

const [notifications, setNotifications] = createStore<{
	notificationsUnread: number;
	chatUnread: number;
}>({
	notificationsUnread: 0,
	chatUnread: 0,
});

export const notificationsContext = createContext({ notifications, setNotifications });

export const NotificationsProvider: ParentComponent = (props) => {
	onMount(() => {
		getNotificationsHistory().then((res) => {
			setNotifications("notificationsUnread", res.metadata.num_unread);
		});
		getUnreadCount().then((res) => setNotifications("chatUnread", res.unread_messages));
	});

	return (
		<notificationsContext.Provider value={{ notifications, setNotifications }}>
			{props.children}
		</notificationsContext.Provider>
	);
};
